export const FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST = 'FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST'
export const FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS = 'FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS'
export const FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE = 'FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE'

export const LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST = 'LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST'
export const LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS = 'LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS'
export const LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE = 'LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE'

export const DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST =
  'DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST'
export const DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS =
  'DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS'
export const DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE =
  'DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE'

export const DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST =
  'DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST'
export const DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS =
  'DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS'
export const DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE =
  'DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE'

export const EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST =
  'EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST'
export const EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS =
  'EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS'
export const EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE =
  'EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE'

export const DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST = 'DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST'
export const DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS = 'DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS'
export const DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE = 'DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE'